// =============================
// ContactPro.jsx (React)
// =============================
import React from "react";
import "./Stylesheets/Contact.css";
import karl from "./Images/karl.jpg"
import marie from "./Images/marie.jpg"
import steve from "./Images/steven.jpeg"


/**
 * OFEAA — Professional Contact Page
 *
 * Replace avatar `src` values with your real images. They render as round.
 */
export default function ContactPro() {
  const hq = {
    name: "OFEAA Head Office",
    addressLine1: "808 Crystal Lake Road",
    addressLine2: "Kinmount, Ontario, K0M 2A0",
    phone: "+1-705-488-2660",
    phoneDisplay: "(705) 488-2660",
    fax: "+1-705-488-2835",
    faxDisplay: "(705) 488-2835",
    email: "info@ontarioaquaculture.net",
    website: "https://ontarioaquaculture.net",
  };

  const people = [
    {
      name: "Karl Dickob",
      title: "President",
      phone: "+1-705-488-2660",
      phoneDisplay: "(705) 488-2660",
      fax: "+1-705-488-2835",
      faxDisplay: "(705) 488-2835",
      email: "karl.dickob@ontarioaquaculture.net",
      avatar: karl, // TODO: replace with real photo
    },
    {
      name: "Marie Windover",
      title: "Treasurer / Secretary",
      phone: "+1-705-657-9142",
      phoneDisplay: "(705) 657-9142",
      email: "marie.windover@ontarioaquaculture.net",
      avatar:  marie, // TODO: replace with real photo
    },
    {
      name: "Dr. Steven Zaichuk",
      title: "Director",
      phone: "+1-519-833-2503",
      phoneDisplay: "(519) 833-2503",
      email: "steven.zaichuk@ontarioaquaculture.net",
      avatar: steve, // TODO: replace with real photo
    },
  ];

  return (
    <section className="ofeaa-contact" aria-label="Contact Ontario Fishery Enhancement and Aquaculture Association">
      {/* Hero */}
      <header className="ofeaa-contact__hero">
        <div className="ofeaa-contact__hero-backdrop" aria-hidden="true" />
        <div className="ofeaa-contact__hero-inner">
          <h1 className="ofeaa-contact__title">Contact Us</h1>
          <p className="ofeaa-contact__subtitle">
            We’re here to support Ontario’s aquaculture community. Reach the head office or contact an executive directly.
          </p>
        </div>
       
      </header>

      {/* Body */}
      <div className="ofeaa-contact__container">


        {/* People Grid */}
        <section className="ofeaa-contact__grid">
          {people.map((p, i) => (
            <article key={i} className="ofeaa-contact__card ofeaa-contact__person">
              <img className="ofeaa-contact__avatar" src={p.avatar} alt="" aria-hidden="true" />
              <h3 className="ofeaa-contact__name">{p.name}</h3>
              <p className="ofeaa-contact__role">{p.title}</p>
              <div className="ofeaa-contact__rows">
                {p.phone && (
                  <div className="ofeaa-contact__row">
                    <IconPhone />
                    <a className="ofeaa-contact__link" href={`tel:${p.phone}`}>{p.phoneDisplay}</a>
                  </div>
                )}
          
                <div className="ofeaa-contact__row">
                  <IconMail />
                  <a className="ofeaa-contact__link" href={`mailto:${p.email}`}>{p.email}</a>
                </div>
              </div>
            </article>
          ))}
        </section>

 
        {/* Optional: Contact Form (static markup; hook up as needed) */}
        {/*
        <section className="ofeaa-contact__card">
          <h2 className="ofeaa-contact__h2">Send us a message</h2>
          <form className="ofeaa-contact__form" onSubmit={(e)=>e.preventDefault()}>
            <div className="ofeaa-contact__form-grid">
              <label className="ofeaa-contact__label">Full name
                <input className="ofeaa-contact__input" type="text" required placeholder="Jane Doe" />
              </label>
              <label className="ofeaa-contact__label">Email
                <input className="ofeaa-contact__input" type="email" required placeholder="you@example.com" />
              </label>
              <label className="ofeaa-contact__label">Phone (optional)
                <input className="ofeaa-contact__input" type="tel" placeholder="(555) 555-5555" />
              </label>
              <label className="ofeaa-contact__label ofeaa-contact__label--full">Message
                <textarea className="ofeaa-contact__textarea" rows="5" required placeholder="How can we help?" />
              </label>
            </div>
            <button className="ofeaa-contact__submit" type="submit">Submit</button>
          </form>
        </section>
        */}
      </div>
    </section>



  );
}

/* =============================
   Inline SVG icons (no emoji)
   ============================= */
function IconPhone(){return(<svg className="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h0a12 12 0 006 6h0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-1C10.82 21 3 13.18 3 4V5z" fill="currentColor" opacity=".9"/></svg>)}
function IconFax(){return(<svg className="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h12v6h3a1 1 0 011 1v9a2 2 0 01-2 2H4a2 2 0 01-2-2V10a1 1 0 011-1h3V3zm2 0v6h8V3H8zm1 10h6v2H9v-2zm0 3h6v2H9v-2z" fill="currentColor" opacity=".9"/></svg>)}
function IconMail(){return(<svg className="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6a2 2 0 012-2h14a2 2 0 012 2v.5l-9 6-9-6V6zm0 3.2l8.4 5.6a2 2 0 002.2 0L22 9.2V18a2 2 0 01-2 2H4a2 2 0 01-2-2V9.2z" fill="currentColor" opacity=".9"/></svg>)}
function IconGlobe(){return(<svg className="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3a9 9 0 100 18 9 9 0 000-18zm0 0c2.5 0 4.5 4 4.5 9S14.5 21 12 21 7.5 17 7.5 12 9.5 3 12 3zm-7 9h14M12 3a12 12 0 010 18" fill="none" stroke="currentColor" strokeWidth="1.6"/></svg>)}
function IconPin(){return(<svg className="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" fill="currentColor"/></svg>)}

// =============================
// ContactPro.css (place in ./Stylesheets/ContactPro.css)
// =============================

 